import { Input, ViewContainerRef, Directive, AfterViewInit, ElementRef, inject } from '@angular/core';
import { BooktechAppService } from '../services/booktech-app.service';

/*
Husk å slå av autofocus på modalen som inndatafeltet ligger: 
  [nzAutofocus]="null"
*/
@Directive({
  selector: '[focus-on-load]',
  standalone: true,
})
export class FocusOnLoadDirective implements AfterViewInit {
  bas = inject(BooktechAppService);

  constructor(
    private viewContainer: ViewContainerRef,
    // private el: ElementRef
  ) {
    // console.log("FocusOnLoadDirective");
    //const container = (<any>this.viewContainer)['_lContainer'][0];
    const container = this.viewContainer.element.nativeElement;
    // console.log("FocusOnLoadDirective.constructor container: ", container);
    if (container instanceof HTMLElement) {
      this.inputBox = <HTMLInputElement>container;
    } else {
      this.inputBox = container[0];
    }
  }

  private readonly inputBox!: any;

  private _autofocus = true;
  @Input() public set autofocus(value: any) {
    if (value === '') {
      // <bs-select2 ... autofocus></bs-select2>
      value = true;
    }
    this._autofocus = value;  
  }

  ngAfterViewInit() {
    setTimeout(() => {
    
      if (this._autofocus) {
        if (this.bas.envtest) console.log("FocusOnLoadDirective.ngAfterViewInit inputBox: ", this.inputBox);
        this.inputBox.focus();
        // this.el.nativeElement.focus();
      }
    }, 10);
  }
}

